import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatButtonModule } from '@angular/material/button';

import { HeroModule } from 'src/app/shared/components/hero/hero.module';
import { InvoiceModule } from '../../../shared/components/invoice/invoice.module';
import { PackageModule } from '../../../shared/components/package/package.module';
import { ProductModule } from "../../../shared/components/product/product.module";
import { ProductChoiceModule } from "../../../shared/components/product-choice/product-choice.module";

import {PaymentFormModule} from "../../../shared/components/payment-form/payment-form.module";
import {SelfAttendanceAutoRechargePaymentChangeComponent} from "./auto-recharge-payment-change.component";
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  imports: [
    CommonModule,
    
    MatButtonModule,
    HeroModule,
    InvoiceModule,
    PackageModule,
    ProductModule,
    ProductChoiceModule,
    MatIconModule,
    PaymentFormModule
  ],
  exports: [
    SelfAttendanceAutoRechargePaymentChangeComponent
  ],
  providers: [
  ],
  declarations: [
    SelfAttendanceAutoRechargePaymentChangeComponent
  ]
})

export class SelfAttendanceAutoRechargePaymentChangeModule { }
